
import { Button } from "@/components/ui/button";
import { InvestmentOpportunity } from "@/types/investment";

interface FormActionsProps {
  investment: InvestmentOpportunity;
  onCancel: () => void;
}

const FormActions = ({ investment, onCancel }: FormActionsProps) => {
  return (
    <div className="flex space-x-4 pt-6">
      <Button type="submit" className="bg-yellow-800 hover:bg-yellow-900">
        {investment.id ? 'Update Investment' : 'Create Investment'}
      </Button>
      <Button type="button" variant="outline" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  );
};

export default FormActions;
